(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ttl-mosaic"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.ttlMosaicPeek) return;
    window.ttlMosaicPeek = true;
    // Touch a card: its second photo shows. Lift without opening the product (a scroll, or a
    // press that didn't navigate) and it stays for HOLD ms, then the first photo comes back.
    // A tap that opens the product just opens it. Touching another card puts the first back
    // at once. Nothing here tracks movement: it only reacts to touching and lifting.
    // Delegated, so cards added by the theme editor need no wiring.
    var HOLD = 2000;
    var shown = null, timer = null;
    function card(e) {
      var c = e.target.closest && e.target.closest('[data-ttl-peek] .ttl-card');
      return c && c.querySelector('.ttl-card__alt') ? c : null;
    }
    function hide() {
      clearTimeout(timer); timer = null;
      if (shown) { shown.classList.remove('is-peek'); shown = null; }
    }
    document.addEventListener('touchstart', function (e) {
      var c = card(e);
      if (c === shown) { clearTimeout(timer); timer = null; return; }
      hide();
      if (!c) return;
      shown = c;
      c.classList.add('is-peek');
    }, { passive: true });
    function lifted(e) {
      if (!shown || (e.touches && e.touches.length)) return;
      clearTimeout(timer);
      timer = setTimeout(hide, HOLD);
    }
    document.addEventListener('touchend', lifted, { passive: true });
    document.addEventListener('touchcancel', lifted, { passive: true });
    window.addEventListener('pagehide', hide);
  })();

  } catch(e) { console.error(e); }
})();
})();
